
























import { defineComponent, PropType } from '@nuxtjs/composition-api';
import get from 'lodash/get';
import { SfModal } from '@storefront-ui/vue';
import type { LicensePlate } from '../composables/useLicensePlateRegistration';
import type { KjoretoydataListe } from '../composables/useLicensePlateFinder';

export default defineComponent({
  name: 'LicensePlateInformationModal',
  props: {
    plate: {
      type: Object as PropType<LicensePlate>,
      required: true
    }
  },
  components: {
    SfModal
  },
  setup(props) {
    const licensePlate = props.plate as LicensePlate;
    const info = licensePlate.info ? JSON.parse(licensePlate.info) as KjoretoydataListe : null;

    const information = {
      Kjennemerke: licensePlate.license_plate,
      Merke: licensePlate.brand,
      Modell: licensePlate.model,
      ...info ? {
        Understellsnummer: get(info, 'kjoretoyId.understellsnummer', ''),
        'Godjenningsår': get(info, 'godkjenning.tekniskGodkjenning.kjoretoyklassifisering.nasjonalGodkjenning.nasjonaltGodkjenningsAr', ''),
        Drivstoff: get(info, 'godkjenning.tekniskGodkjenning.tekniskeData.miljodata.miljoOgdrivstoffGruppe[0].drivstoffKodeMiljodata.kodeBeskrivelse', ''),
        Egenvekt: get(info, 'godkjenning.tekniskGodkjenning.tekniskeData.vekter.egenvekt', ''),
        'Aksel 1': get(info, 'godkjenning.tekniskGodkjenning.tekniskeData.dekkOgFelg.akselDekkOgFelgKombinasjon[0].akselDekkOgFelg[0]', ''),
        'Aksel 2': get(info, 'godkjenning.tekniskGodkjenning.tekniskeData.dekkOgFelg.akselDekkOgFelgKombinasjon[0].akselDekkOgFelg[1]', ''),
      } : {}
    }

    function transformString(string: string) {
      return string.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
    }

    function maybeReplaceBool(value: string | boolean) {
      if (value === true) {
        return 'Ja';
      }
      if (value === false) {
        return 'Nei';
      }
      return value;
    }

    return {
      information,
      transformString,
      maybeReplaceBool
    }
  }
});
